module.exports = __webpack_public_path__ + "img/prevent-4.c24e5649.png";